import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { ManagerProfileComponentComponent } from '@modules/parkingManager/manager-profile-component/manager-profile-component.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { ManagerListComponent } from '@modules/parkingManager/manager-list/manager-list.component';
import { SidebarModule } from 'primeng/sidebar';
import { MenuModule } from 'primeng/menu';
import { DeactivateModalComponent } from '@modules/parkingManager/manager-list/deactivate-modal/deactivate-modal.component';
import { PasswordModule } from 'primeng/password';
import { ManagerEditProfileComponent } from '@modules/parkingManager/manager-edit-profile/manager-edit-profile.component';
import { BnNgIdleService } from 'bn-ng-idle';
import { DriverService } from '@core/services/driver.service';
import { ButtonModule } from 'primeng/button';
import { ReactiveFormsModule,FormsModule } from '@angular/forms';
import { NgOtpInputModule } from 'ng-otp-input';
import { DatePipe } from '@angular/common';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToastModule } from 'primeng/toast';
import { AccordionModule } from 'primeng/accordion';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { BookingFlowModule } from "./shared/components/booking-flow/booking-flow.module";
import { GuestEntryComponentComponent } from './guest-entry-component/guest-entry-component.component';
import { CommonPopupComponent } from '@public/common-popup/common-popup.component';
import { NoLeadingSpaceDirective } from './shared/directive/out-side-click.directive';
import { DeviceRedirectLink } from './public/device-redirectLink/device-redirectLink.component';
import { CookieService } from 'ngx-cookie-service';
import { FeatureBoxComponent } from '@public/feature-box/feature-box.component';
import { ChangePasswordComponent } from './public/change-password/change-password.component';
import { GenerateTruxLinkComponent } from './public/generate-trux-link/generate-trux-link.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { TruxService } from '@core/services/trux.service';
import { DispatcherV1Component } from '@public/dispatcher-v1/dispatcher-v1.component';
import { DriverV1Component } from '@public/driver-v1/driver-v1.component';
import { HelpDeskComponent } from '@public/help-desk/help-desk.component';
import { LandingV1Component } from '@public/landing-v1/landing-v1.component';
import { ParkingLotV1Component } from '@public/parking-lot-v1/parking-lot-v1.component';
import { AuthModule } from '@auth/auth.module';
import { WebTermsConditionsComponent } from '@public/web-terms-privacy/web-terms-conditions/web-terms-conditions.component';
import { WebPrivacyPolicyComponent } from '@public/web-terms-privacy/web-privacy-policy/web-privacy-policy.component';
import { TruxLogin } from '@public/trux-login/trux-login.component';
import { mobilePageRedirectionComponent } from '@public/mobile-pageRedirection/mobile-pageRedirection.component';
import { AuthInterceptor } from '@core/interceptors/auth.interceptor';
import { DeviceDetectorComponentComponent } from './public/device-detector-component/device-detector-component.component';
import { SurveyComponent } from './public/survey/survey.component';
import { RedirectUrlAfterPaymentComponent } from './public/redirect-url-after-payment/redirect-url-after-payment.component';
import { NetworkModalComponent } from './public/network-modal/network-modal.component';
import { NetworkService } from './core/services/network.service';
import { BookingPaymentStatusComponent } from '@public/booking-payment-status/booking-payment-status.component';
import { BookingPaymentStatusPopupComponent } from '@public/booking-payment-status-popup/booking-payment-status-popup.component';
import { ConfigService } from '@core/services/config.service';

export function initConfig(configService: ConfigService) {
  return () => configService.loadConfig();
}
@NgModule({
  declarations: [
    AppComponent,
    ManagerProfileComponentComponent,
    ManagerListComponent,
    DeactivateModalComponent,
    ManagerEditProfileComponent,
    WebTermsConditionsComponent,
    WebPrivacyPolicyComponent,
    HelpDeskComponent,
    LandingV1Component,
    ParkingLotV1Component,
    DriverV1Component,
    GuestEntryComponentComponent,
    CommonPopupComponent,
    DispatcherV1Component,
    NoLeadingSpaceDirective,
    DeviceRedirectLink,
    mobilePageRedirectionComponent,
    FeatureBoxComponent,
    ChangePasswordComponent,
    GenerateTruxLinkComponent,
    TruxLogin,
    BookingPaymentStatusComponent,
    BookingPaymentStatusPopupComponent,
    DeviceDetectorComponentComponent,
    SurveyComponent,
    RedirectUrlAfterPaymentComponent,
    NetworkModalComponent
    ],
  imports: [
    SharedModule,
    ReactiveFormsModule,
    CoreModule,
    ToggleButtonModule,
    AppRoutingModule,
    NgOtpInputModule,
    HttpClientModule,
    NgxIntlTelInputModule,
    BrowserAnimationsModule,
    AccordionModule,
    BadgeModule,
    AvatarModule,
    MultiSelectModule,
    ButtonModule,
    FormsModule,
    SidebarModule,
    MenuModule,
    PasswordModule,
    ToastModule,
    BookingFlowModule,
    SidebarModule,
    AuthModule,
    NgCircleProgressModule.forRoot({
    })
],
  providers: [
    CookieService,
    NetworkService,
    BnNgIdleService,DriverService,
    DatePipe,DynamicDialogConfig,
    DynamicDialogRef,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    TruxService,
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      deps: [ConfigService],
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }